import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import FiberManualRecordRoundedIcon from '@material-ui/icons/FiberManualRecordRounded'
import PersonOutlineIcon from '@material-ui/icons/PersonOutline'
import StarBorderIcon from '@material-ui/icons/StarBorder'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder'
import CloseIcon from '@material-ui/icons/Close'
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';
import { theme } from '../../../Root.mui-theme'
import { PILL_COLOR } from 'common/Pill/Pill.component'

const usePill = props => {

    const COLORS_PALETTE_PILL = {
        [PILL_COLOR.DEFAULT]: theme.palette.grey[300],
        [PILL_COLOR.RED]: theme.palette.error.dark,
        [PILL_COLOR.GREEN]: theme.palette.success.dark,
        [PILL_COLOR.GREEN_HIGHLIGHT]: theme.palette.secondary.main,
        [PILL_COLOR.YELLOW]: theme.palette.warning.dark,
        [PILL_COLOR.YELLOW_HIGHLIGHT]: theme.palette.warning.dark,
        [PILL_COLOR.PURPLE_HIGHLIGHT]: 'rgba(107, 51, 199, 0.75)',
        [PILL_COLOR.GRAY01]: 'rgba(112, 112, 112, 1)',
        [PILL_COLOR.GRAY03]: theme.palette.grey[300],
        [PILL_COLOR.GRAY05]: theme.palette.grey[500],
        [PILL_COLOR.GRAY08]: theme.palette.grey[800],
        [PILL_COLOR.LIGHT_BLUE]: theme.palette.info.dark,
    }

    const icon = {
        circle: <FiberManualRecordRoundedIcon />,
        avatar: <PersonOutlineIcon style={{ fontSize: 'large' }} />,
        star: <StarBorderIcon style={{ fontSize: 'large' }} />,
        clock: <QueryBuilderIcon style={{ fontSize: 'large' }} />,
        'circle-color': <FiberManualRecordRoundedIcon style={{ color: COLORS_PALETTE_PILL[props.color] }} />,
        check: <CheckCircleOutlineOutlinedIcon style={{ fontSize: 'large', color: COLORS_PALETTE_PILL[props.color]  }} />,
        close: <CloseIcon style={{ fontSize: 'large', color: COLORS_PALETTE_PILL[props.color]  }} />
    }[props.leftimg]

    const delIcon = {
        default: <CloseIcon />,
        expand: <ExpandMoreIcon viewBox={'2 2 20 20'} />
    }

    const deleteIcon = delIcon[props.rightimg] || props.rightimg

    let root = {
        fontFamily: 'Open Sans',
        fontStyle: 'normal',
        fontWeight: '400',
        letterSpacing: '0em',
        textAlign: 'center',
        borderRadius: '100px',
        color: theme.palette.grey[700],
        border: '1px solid transparent',
        '& circle': {
            r: 9.6
        },
        '& svg': {
            width: '1.125rem',
            height: '1.125rem'
        },
        '& svg:first-child': {
            marginLeft: '0.5rem',
            marginRight: '-4.5px'
        },
        '& span + svg': {
            marginRight: '0.5rem !important',
            marginLeft: '-5px',
            color: theme.palette.grey[700]
        }
    }

    let sizeRoot
    if (props.size === 'small') {
        sizeRoot = {
            fontSize: '0.813rem',
            lineHeight: '1.125rem',
            height: '1.625rem',
            '& svg:first-child': {
                marginLeft: '0.25rem',
                marginRight: '-2px'
            },
            '& span + svg': {
                marginRight: '0.25rem',
                marginLeft: '-2px'
            }
        }
    } else if (props.size === 'medium') {
        sizeRoot = {
            fontSize: '0.875rem',
            lineHeight: '1.188rem',
            height: '1.875rem'
        }
    } else if (props.size === 'small-highLight') {
        sizeRoot = {
            fontWeight: '600',
            fontSize: '0.813rem',
            lineHeight: '1.125rem',
            height: '1.625rem',
            '& svg:first-child': {
                marginLeft: '0.25rem',
                marginRight: '-6px'
            },
            '& .MuiChip-label': {
                paddingRight: '8px'
            }

        }
    } else {
        sizeRoot = {
            fontSize: '1rem',
            lineHeight: '1.375rem',
            height: '2.25rem'
        }
    }

    let outlined = {}
    let colorRoot = {}
    switch (props.color) {
        case 'default':
            colorRoot = {
                background: theme.palette.grey[300],
                '& .MuiChip-icon': {
                    color: theme.palette.grey[700]
                },
                '&:hover': { background: theme.palette.grey[200] },
                '&:focus': {
                    boxShadow: '1px 1px 3px rgba(0, 0, 0, 0.3);',
                    background: theme.palette.grey[300]
                },
                '&:active': {
                    color: theme.palette.grey[200],
                    background: theme.palette.grey[600],
                    '& svg': {
                        color: theme.palette.grey[200]
                    }
                },
                '&.Mui-disabled': {
                    color: theme.palette.grey[400],
                    background: `${theme.palette.grey[100]} !important`,
                    borderColor: theme.palette.grey[300],
                    '& svg': {
                        color: theme.palette.grey[400]
                    }
                }
            }
            outlined = {
                borderColor: theme.palette.grey[800],
                '&:hover': { background: theme.palette.grey[200] },
                '&:focus': {
                    outline: `2px solid ${theme.palette.grey[800]} !important`
                },
                '&:active': {
                    color: theme.palette.grey[800],
                    background: `${theme.palette.grey[300]} !important`,
                    '& svg': {
                        color: theme.palette.grey[800]
                    }
                },
                '&.Mui-disabled': {
                    color: theme.palette.grey[500],
                    borderColor: theme.palette.grey[400],
                    '& svg': {
                        color: theme.palette.grey[500]
                    }
                }
            }
            break
        case 'rojo':
            colorRoot = {
                borderColor: theme.palette.error.dark,
                background: theme.palette.error.light,
                '& .MuiChip-icon': {
                    color: theme.palette.grey[700]
                },
                '&:hover': {
                    background: '#FFF5F5'
                },
                '&:focus': {
                    color: theme.palette.grey[800],
                    boxShadow: '1px 1px 3px rgba(192, 32, 32, 0.5)',
                    background: theme.palette.error.light
                },
                '&:active': {
                    color: theme.palette.grey[200],
                    background: '#E14F4F',
                    '& span, svg': {
                        color: theme.palette.grey[200]
                    }
                },
                '&.Mui-disabled': {
                    borderColor: theme.palette.error.light,
                    background: '#FFF5F5',
                    '& svg:first-child': {
                        color: theme.palette.grey[500]
                    }
                }
            }
            outlined = {
                '&:hover': { background: '#FFF5F5 !important' },
                '&:focus': {
                    outline: `2px solid ${theme.palette.error.dark} !important`
                },
                '&:active': {
                    color: theme.palette.error.dark,
                    backgroundColor: '#FFF5F5 !important',
                    '& span, svg': {
                        color: theme.palette.grey[500]
                    }
                }
            }
            break
        case 'verde':
            colorRoot = {
                borderColor: theme.palette.success.dark,
                background: theme.palette.success.light,
                '& .MuiChip-icon': {
                    color: theme.palette.grey[700]
                },
                '&:hover': {
                    background: '#FBFFFB'
                },
                '&:focus': {
                    boxShadow: '1px 1px 3px rgba(44, 135, 44, 0.5)',
                    background: theme.palette.success.light
                },
                '&:active': {
                    color: theme.palette.grey[800],
                    background: '#ABFFAB',
                    '& span, svg': {
                        color: theme.palette.grey[800]
                    }
                },
                '&.Mui-disabled': {
                    borderColor: '#CFF8CF',
                    '& svg:first-child': {
                        color: theme.palette.grey[500]
                    }
                }
            }
            outlined = {
                '&:hover': { background: theme.palette.success.light },
                '&:focus': {
                    outline: `2px solid ${theme.palette.success.dark} !important`
                },
                '&:active': {
                    color: theme.palette.success.dark,
                    background: `${theme.palette.success.light}  !important`,
                    '& span, svg': {
                        color: theme.palette.success.dark
                    }
                }
            }
            break
        case 'amarillo':
            colorRoot = {
                borderColor: theme.palette.warning.dark,
                background: theme.palette.warning.light,
                '& .MuiChip-icon': {
                    color: theme.palette.grey[700]
                },
                '&:hover': {
                    background: '#FFFEFB'
                },
                '&:focus': {
                    boxShadow: '1px 1px 3px rgba(255, 153, 0, 0.5)',
                    background: theme.palette.warning.light
                },
                '&:active': {
                    color: theme.palette.grey[800],
                    background: '#FFEAB6',
                    '& span, svg': {
                        color: theme.palette.grey[800]
                    }
                },
                '&.Mui-disabled': {
                    background: '#FFFEFB',
                    borderColor: '#FFDA7C',
                    '& svg:first-child': {
                        color: theme.palette.grey[500]
                    }
                }
            }
            outlined = {
                '&:hover': { background: theme.palette.warning.light },
                '&:focus': {
                    outline: `2px solid ${theme.palette.warning.dark} !important`
                },
                '&:active': {
                    color: theme.palette.warning.dark,
                    background: `${theme.palette.warning.light} !important`,
                    '& span, svg': {
                        color: theme.palette.warning.dark
                    }
                },
                '&.Mui-disabled': {
                    borderColor: '#FFECBC',
                    '& svg:first-child': {
                        color: theme.palette.grey[500]
                    }
                }
            }
            break
        case 'celeste':
            colorRoot = {
                borderColor: theme.palette.info.dark,
                background: theme.palette.info.light,
                '& .MuiChip-icon': {
                    color: theme.palette.grey[700]
                },
                '&:hover': {
                    background: '#FAFEFF'
                },
                '&:focus': {
                    boxShadow: '1px 1px 3px rgba(54, 128, 153, 0.5)',
                    background: theme.palette.info.light
                },
                '&:active': {
                    color: theme.palette.grey[800],
                    background: '#A0E1F6',
                    '& span, svg': {
                        color: theme.palette.grey[800]
                    }
                },
                '&.Mui-disabled': {
                    background: '#FAFEFF',
                    borderColor: '#E0F7FF',
                    '& svg:first-child': {
                        color: theme.palette.grey[500]
                    }
                }
            }
            outlined = {
                '&:hover': { background: theme.palette.info.light },
                '&:focus': {
                    outline: `2px solid ${theme.palette.info.dark} !important`
                },
                '&:active': {
                    color: theme.palette.info.dark,
                    background: `${theme.palette.info.light} !important`,
                    '& span, svg': {
                        color: theme.palette.info.dark
                    }
                },
                '&.Mui-disabled': {
                    borderColor: '#BCEEFF',
                    '& svg:first-child': {
                        color: theme.palette.grey[500]
                    }
                }
            }
            break
        case 'naranja':
            colorRoot = {
                borderColor: theme.palette.warning.dark,
                '& .MuiChip-icon': {
                    color: theme.palette.secondary.darkx2
                },
            }
            break
        case 'gris08':
            colorRoot = {
                borderColor: theme.palette.grey[800],
                background: theme.palette.grey[200],
                '& .MuiChip-icon': {
                    color: theme.palette.grey[800]
                },
                '&:hover': {
                    background: theme.palette.grey[100]
                },
                '&:focus': {
                    background: theme.palette.grey[200],
                    boxShadow: '1px 1px 3px rgba(0, 0, 0, 0.3)'
                },
                '&:active': {
                    color: theme.palette.grey[800],
                    background: `${theme.palette.grey[400]} !important`,
                    '& span, svg': {
                        color: theme.palette.grey[800]
                    }
                },
                '&.Mui-disabled': {
                    borderColor: theme.palette.grey[400],
                    '& svg:first-child': {
                        color: theme.palette.grey[400]
                    }
                }
            }
            outlined = {
                '&:hover': { background: theme.palette.grey[200] },
                '&:focus': {
                    outline: `2px solid ${theme.palette.grey[800]} !important`
                },
                '&:active': {
                    backgroundColor: `${theme.palette.grey[400]} !important`
                }
            }
            break
        case 'gris05':
            colorRoot = {
                borderColor: theme.palette.grey[500],
                background: theme.palette.grey[200],
                '& .MuiChip-icon': {
                    color: theme.palette.grey[500]
                },
                '&:hover': {
                    background: theme.palette.grey[50]
                },
                '&:focus': {
                    background: theme.palette.grey[200],
                    boxShadow: '1px 1px 3px rgba(0, 0, 0, 0.3)'
                },
                '&:active': {
                    background: theme.palette.grey[300]
                },
                '&.Mui-disabled': {
                    borderColor: theme.palette.grey[400],
                    '& svg:first-child': {
                        color: theme.palette.grey[400]
                    }
                }
            }
            outlined = {
                '&:hover': { background: theme.palette.grey[200] },
                '&:focus': {
                    outline: `2px solid ${theme.palette.grey[500]} !important`
                },
                '&:active': {
                    background: `${theme.palette.grey[300]} !important`
                }
            }
            break
        case 'gris03':
            colorRoot = {
                borderColor: theme.palette.grey[300],
                background: theme.palette.grey[200],
                '& .MuiChip-icon': {
                    color: theme.palette.grey[300]
                },
                '&:focus': {
                    background: theme.palette.grey[200],
                    boxShadow: '1px 1px 3px rgba(0, 0, 0, 0.3)'
                },
                '&:hover': {
                    background: theme.palette.grey[50]
                },
                '&:active': {
                    background: `${theme.palette.grey[500]} !important`,
                    color: theme.palette.grey[300],
                    '& span': {
                        color: theme.palette.grey[800]
                    },
                    '& span+svg': {
                        color: theme.palette.grey[800]
                    }
                },
                '&.Mui-disabled': {
                    '& svg:first-child': {
                        color: theme.palette.grey[300]
                    }
                }
            }
            outlined = {
                borderColor: theme.palette.grey[600],
                '&:hover': { background: theme.palette.grey[200] },
                '&:focus': {
                    outline: `2px solid ${theme.palette.grey[600]} !important`
                },
                '&:active': {
                    borderColor: theme.palette.grey[300],
                    background: `${theme.palette.grey[600]} !important`,
                    color: theme.palette.grey[300],
                    '& span': {
                        color: theme.palette.grey[300]
                    },
                    '& span+svg': {
                        color: theme.palette.grey[300]
                    }
                },
                '&.Mui-disabled': {
                    borderColor: theme.palette.grey[300]
                }
            }
            break
        case 'gris01':
            colorRoot = {
                background: 'rgba(112, 112, 112, 1)',
                color: 'rgba(255, 255, 255, 1)',
            }
            break
        case 'amarillo-highlight':
            colorRoot = {
                borderColor: theme.palette.warning.dark,
                background: theme.palette.highlight.yellow,
                '& span,svg': {
                    color: theme.palette.grey[800]
                },
                '& .MuiChip-icon': {
                    color: theme.palette.grey[800]
                },
                '&:hover': {
                    background: theme.palette.highlight.yellow
                },
                '&:focus': {
                    background: theme.palette.highlight.yellow
                },
                '&:active': {
                    background: theme.palette.highlight.yellow
                }
            }
            outlined = {
                borderColor: theme.palette.warning.dark,
                background: theme.palette.highlight.yellow,
                '& .MuiChip-icon': {
                    color: theme.palette.grey[800]
                }
            }
            break
        case 'violeta-highlight':
            colorRoot = {
                borderColor: 'rgba(107, 51, 199, 0.75)',
                background: 'rgba(181, 143, 243, 0.75)',
                '& span,svg': {
                    color: theme.palette.grey[800]
                },
                '& .MuiChip-icon': {
                    color: theme.palette.grey[800]
                },
                '&:hover': {
                    background: 'rgba(181, 143, 243, 0.75)'
                },
                '&:focus': {
                    background: 'rgba(181, 143, 243, 0.75)'
                },
                '&:active': {
                    background: 'rgba(181, 143, 243, 0.75)'
                }
            }
            break
        case 'verde-highlight':
            colorRoot = {
                borderColor: theme.palette.secondary.main,
                background: theme.palette.secondary.dark,
                '& span,svg': {
                    color: theme.palette.grey[800]
                },
                '& .MuiChip-icon': {
                    color: theme.palette.grey[800]
                },
                '&:hover': {
                    background: theme.palette.secondary.dark
                },
                '&:focus': {
                    background: theme.palette.secondary.dark
                },
                '&:active': {
                    background: theme.palette.secondary.dark
                }
            }
            break
        default:
            break
    }

    root = {
        ...root,
        ...sizeRoot,
        ...colorRoot,
        '&:active': {
            ...colorRoot['&:active'],
            boxShadow: 'none'
        },
        '&.Mui-disabled': {
            ...colorRoot['&.Mui-disabled'],
            color: theme.palette.grey[500],
            '& span + svg': {
                color: theme.palette.grey[500]
            }
        },
        '&.MuiChip-deletable': {
            '& span+svg': {
                '&:hover': {
                    color: theme.palette.grey[700],
                    cursor: 'pointer'
                }
            }
        }
    }
    outlined = {
        ...outlined,
        background: theme.palette.grey[100],
        '&:focus': {
            ...outlined['&:focus'],
            background: `${theme.palette.grey[100]} !important`
        },
        '&:active': {
            ...outlined['&:active'],
            boxShadow: 'none',
            outline: 'none !important'
        },
        '&.Mui-disabled': {
            ...outlined['&.Mui-disabled'],
            background: theme.palette.grey[100]
        }
    }
    let disabled = {
        color: theme.palette.grey[500],
        opacity: '1 !important'
    }

    let deletable = {}

    if (!props.clickable) {
        delete root['&:hover']
        delete root['&:focus']
        delete root['&:active']
        delete outlined['&:hover']
        delete outlined['&:focus']
        delete outlined['&:active']
        deletable = {
            '&:focus': {
                background: colorRoot.background
            }
        }
        outlined = {
            ...outlined,
            '&.MuiChip-deletable': {
                '&:focus': {
                    background: theme.palette.grey[100]
                }
            }
        }

        root = {
            ...root,
            '& span+svg': {
                '&:hover': {
                    cursor: 'default'
                }
            }
        }
    }

    const useStyles = makeStyles(
        {
            [`root-${props.color}`]: { ...root },
            outlined,
            disabled,
            deletable
        },
        { name: 'MuiChip' }
    )

    return {
        deleteIcon,
        icon,
        useStyles,
        ...props
    }
}

export default usePill
